import axios from "../axios";

const END_POINT = "/receptions";

const addReception = (reception) => axios.post(`${END_POINT}`, reception);
const getQueueReceptions = (unitId) => axios.get(`${END_POINT}/get-queue-receptions/${unitId}`);
const getQueueReceptionsForDoctors = (unitId) => axios.get(`${END_POINT}/get-queue-receptions-for-doctor/${unitId}`);
const getReceptionTypes = () => axios.get(`/reception-types`);
// const getWaitingAndInRoomAndTriageReceptions = (roomId) => axios.get(`${END_POINT}/get-waiting-and-in-room-and-triage-receptions/${roomId}`);
const getRoomReceptions = (roomId) => axios.get(`${END_POINT}/get-room-receptions/${roomId}`);
const receptionDone = (reception) => axios.post(`${END_POINT}/done-reception`, reception);
const presentPatient = (reception) => axios.get(`${END_POINT}/present-patient/${reception}`);
const presencePatientInRoom = (reception) => axios.get(`${END_POINT}/presence-patient-in-room/${reception}`);
const receptionsSearch = (payload) => axios.post(`${END_POINT}/search`, payload);
const receptionsSearchByUnit = (payload) => axios.post(`${END_POINT}/search-receptions-of-units-accounting`, payload);
const storeSort = async function (receptions) {
    return await axios.post(`${END_POINT}/storeSort`, receptions);
}
const getReception = (receptionId) => axios.get(`${END_POINT}/${receptionId}`);
const commitReception = (receptionId) => axios.get(`${END_POINT}/commit-reception/${receptionId}`);
const sendToCashier = (receptionId) => axios.get(`${END_POINT}/send-to-cashier/${receptionId}`);
const patientTriage = (receptionId) => axios.get(`${END_POINT}/patient-triage/${receptionId}`);
const doneTriage = (receptionId) => axios.get(`${END_POINT}/done-triage/${receptionId}`);
const paidReception = (receptionId) => axios.get(`${END_POINT}/paid-reception/${receptionId}`);
const deleteReceptionRequest = (receptionId) => axios.get(`${END_POINT}/request-remove/${receptionId}`);
const rejectReceptionRequest = (receptionId) => axios.get(`${END_POINT}/reject-request-remove/${receptionId}`);
const acceptReceptionRequest = (receptionId) => axios.delete(`${END_POINT}/accept-deletion/${receptionId}`);

const updateRecallNumberAndEmergency = (payload) => axios.post(`${END_POINT}/update-recall-number-and-emergency`, payload);
const updateReceptionBeforeServiceAssign = (payload) => axios.patch(`${END_POINT}/update-reception-before-service-assign`, payload);
const remove = (receptionId) => axios.delete(`${END_POINT}/${receptionId}`);

const searchReceptionsForCentralCashier = (reception) => axios.post(`${END_POINT}/central-cashier/receptions`, reception);
const searchReceptionsForCashier = (reception) => axios.post(`${END_POINT}/search-receptions-of-cashier`, reception);
const doneAccounting = (receptionId) => axios.get(`${END_POINT}/done-accounting/${receptionId}`);
const searchCurrentDayDoneReceptions = (payload) => axios.post(`${END_POINT}/search-current-day-done-receptions`, payload);
const searchCurrentDayReceptions = (payload) => axios.post(`${END_POINT}/search-current-day-receptions`, payload);
const backToQueue = (payload) => axios.post(`${END_POINT}/back-to-queue`, payload);
const factorPrint = (receptionId) => axios.get(`${END_POINT}/factor-print/${receptionId}`);
const fullFactorPrint = (receptionId, isReprinting) => axios.get(`${END_POINT}/full-factor-print/${receptionId}/${isReprinting}`);
const getPrintHistories = (receptionId) => axios.get(`${END_POINT}/get-factor-print-histories/${receptionId}`);
const factorPrintHistory = (receptionId,factorPrintId,isReprinting ) => axios.get(`${END_POINT}/factor-print-history/${receptionId}/${factorPrintId}/${isReprinting}`);

export {
    addReception,
    getQueueReceptions,
    getQueueReceptionsForDoctors,
    storeSort,
    getReceptionTypes,
    receptionsSearch,
    getReception,
    receptionDone,
    presentPatient,
    getRoomReceptions,
    commitReception,
    patientTriage,
    presencePatientInRoom,
    doneTriage,
    updateRecallNumberAndEmergency,
    // remove,
    searchReceptionsForCentralCashier,
    paidReception,
    deleteReceptionRequest,
    rejectReceptionRequest,
    acceptReceptionRequest,
    sendToCashier,
    searchReceptionsForCashier,
    receptionsSearchByUnit,
    doneAccounting,
    remove,
    searchCurrentDayDoneReceptions,
    updateReceptionBeforeServiceAssign,
    searchCurrentDayReceptions,
    backToQueue,
    factorPrint,
    getPrintHistories,
    factorPrintHistory,
    fullFactorPrint
}
